import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./section1.scss";

export const Section1 = ({}) => cs(
    () => (
        <div className="section1 section1-6te">
            <div className="fields">
                <div className="title" xd-qa-type="label" xd-qa-name="Upload Address List Most Common Address Fields">
                    Most common address fields
                </div>

                <div className="lines">
                    {[
                        "Column A = Full Name",
                        "Column B = Address",
                        "Column C = City",
                        "Column D = State",
                        "Column E = Zip Code",
                    ].map((line, i) => (
                        <div className="line" key={i} xd-qa-type="label" xd-qa-name={"Upload Address List "+line}>
                            {line}
                        </div>
                    ))}
                </div>
            </div>
            <div className="file-formats">
                <div className="title" xd-qa-type="label" xd-qa-name="Upload Address List Supported File Formats">
                    Supported file formats
                </div>

                <div className="lines">
                    {[
                        {
                            icon: {
                                fa: "file-excel-o",
                                color: "#0DA70B",
                            },
                            text: "Microsoft Excel (.xls, .xlsx)",
                            xdQaName: "Upload Address List Microsoft Excel",
                        },
                        // {
                        //
                        //     icon: {
                        //         fa: "file-code-o",
                        //         color: "#EF8A0E",
                        //     },
                        //     text: "Dbase/FoxPro (.dbf)",
                        // },
                        {
                            icon: {
                                fa: "file-text-o",
                                color: "rgba(51,65,80,0.5)",
                            },
                            text: "Tab delimited (.txt, .tab)",
                            xdQaName: "Upload Address List Tab Delimited",
                        },
                        {
                            icon: {
                                fa: "file-text-o",
                                color: "rgba(51,65,80,0.5)",
                            },
                            text: "Comma-separated (.txt, .csv)",
                            xdQaName: "Upload Address List Comma-Separated",
                        },
                    ].map(({icon, text, xdQaName}, i) => (
                        <div className="line" key={i}>
                            {icon && (
                                <i
                                    className={"fa fa-" + icon.fa}
                                    style={{color: icon.color}}
                                    xd-qa-type="icon" 
                                    xd-qa-name={xdQaName}
                                />
                            )}

                            <div className="text" xd-qa-type="label" xd-qa-name={xdQaName}>
                                {text}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <a className="sample" target="_blank" href={require("./excel_popup.gif")} xd-qa-type="link" xd-qa-name="Upload Address List View Sample">
                <div className="img">
                    <img src={require("./excel_popup.gif")} xd-qa-type="image" xd-qa-name="Upload Address List View Sample"/>

                    <div className="zoom">
                        <i className="fa fa-search" xd-qa-type="icon" xd-qa-name="Upload Address List View Sample"/>
                    </div>
                </div>
                <div className="text" xd-qa-type="label" xd-qa-name="Upload Address List View Sample Description">
                    Click to view example screenshots from MS Excel
                </div>
            </a>
        </div>
    ),
);